import { ICONS_NAME } from './icons.constants';

export const INPUT_LG = {
    borderless: true,
    bottomSlots: true,
    class: 'q-input-lg text-body1 form-field',
    debounce: '600',
    hideBottomSpace: true,
    noErrorIcon: true,
    stackLabel: true
};

export const INPUT_MD = {
    borderless: true,
    bottomSlots: true,
    class: 'q-input-md text-body2 form-field',
    debounce: '600',
    hideBottomSpace: true,
    noErrorIcon: true,
    stackLabel: true
};

export const INPUT_NUMBER_LG = {
    borderless: true,
    bottomSlots: true,
    class: 'q-input-lg text-body1 form-field',
    debounce: '600',
    hideBottomSpace: true,
    noErrorIcon: true,
    stackLabel: true,
    type: 'number'
};

export const INPUT_NUMBER_MD = {
    borderless: true,
    bottomSlots: true,
    class: 'q-input-md text-body2 form-field',
    debounce: '600',
    hideBottomSpace: true,
    noErrorIcon: true,
    stackLabel: true,
    type: 'number'
};

export const INPUT_SM = {
    borderless: true,
    bottomSlots: true,
    class: 'q-input-sm text-body2 form-field',
    debounce: '600',
    noErrorIcon: true,
    stackLabel: true
};

export const TEXTAREA_LG = {
    borderless: true,
    bottomSlots: true,
    class: 'q-textarea-lg text-body1 form-field',
    debounce: '600',
    hideBottomSpace: true,
    inputClass: 'scroll',
    noErrorIcon: true,
    stackLabel: true,
    type: 'textarea'
};

export const TEXTAREA_MD = {
    borderless: true,
    bottomSlots: true,
    class: 'q-textarea-md text-body2 form-field',
    debounce: '600',
    hideBottomSpace: true,
    inputClass: 'scroll',
    noErrorIcon: true,
    stackLabel: true,
    type: 'textarea'
};

export const TEXTAREA_SM = {
    borderless: true,
    bottomSlots: true,
    class: 'q-textarea-sm text-body2 form-field',
    debounce: '600',
    hideBottomSpace: true,
    inputClass: 'scroll',
    noErrorIcon: true,
    stackLabel: true,
    type: 'textarea'
};

const selectLgClasses = 'q-select-lg text-body1 form-field';

export const SELECT_SINGLE_LG = {
    borderless: true,
    bottomSlots: true,
    class: selectLgClasses,
    dropdownIcon: ICONS_NAME.CHEVRON_DOWN_SOLID,
    hideBottomSpace: true,
    menuOffset: [0, 8],
    noErrorIcon: true,
    popupContentClass: 'q-select-menu max-width',
    stackLabel: true
};

export const SELECT_SINGLE_LG_SEARCH = {
    borderless: true,
    bottomSlots: true,
    class: selectLgClasses,
    dropdownIcon: ICONS_NAME.CHEVRON_DOWN_SOLID,
    hideBottomSpace: true,
    inputDebounce: '500',
    maxlength: '250', // to replace v-bind="Object.assign({}, inputProps, {maxlength: X})"
    menuOffset: [0, 8],
    noErrorIcon: true,
    popupContentClass: 'q-select-menu max-width',
    stackLabel: true,
    useInput: true
};

export const SELECT_MULTIPLE_LG = {
    borderless: true,
    bottomSlots: true,
    class: selectLgClasses,
    dropdownIcon: ICONS_NAME.CHEVRON_DOWN_SOLID,
    hideBottomSpace: true,
    menuOffset: [0, 8],
    multiple: true,
    noErrorIcon: true,
    popupContentClass: 'q-select-menu max-width',
    stackLabel: true
};

export const SELECT_MULTIPLE_LG_SEARCH = {
    borderless: true,
    bottomSlots: true,
    class: selectLgClasses,
    dropdownIcon: ICONS_NAME.CHEVRON_DOWN_SOLID,
    hideBottomSpace: true,
    inputDebounce: '500',
    maxlength: '250', // to replace v-bind="Object.assign({}, inputProps, {maxlength: X})"
    menuOffset: [0, 8],
    multiple: true,
    noErrorIcon: true,
    popupContentClass: 'q-select-menu max-width',
    stackLabel: true,
    useInput: true
};

const selectMdClasses = 'q-select-md text-body1 form-field';

export const SELECT_SINGLE_MD = {
    borderless: true,
    bottomSlots: true,
    class: selectMdClasses,
    dropdownIcon: ICONS_NAME.CHEVRON_DOWN_SOLID,
    hideBottomSpace: true,
    menuOffset: [0, 8],
    noErrorIcon: true,
    popupContentClass: 'q-select-menu max-width',
    stackLabel: true
};

export const SELECT_SINGLE_MD_SEARCH = {
    borderless: true,
    bottomSlots: true,
    class: selectMdClasses,
    dropdownIcon: ICONS_NAME.CHEVRON_DOWN_SOLID,
    hideBottomSpace: true,
    inputDebounce: '500',
    maxlength: '250', // to replace v-bind="Object.assign({}, inputProps, {maxlength: X})"
    menuOffset: [0, 8],
    noErrorIcon: true,
    popupContentClass: 'q-select-menu max-width',
    stackLabel: true,
    useInput: true
};

export const SELECT_MULTIPLE_MD = {
    borderless: true,
    bottomSlots: true,
    class: selectMdClasses,
    dropdownIcon: ICONS_NAME.CHEVRON_DOWN_SOLID,
    hideBottomSpace: true,
    menuOffset: [0, 8],
    multiple: true,
    noErrorIcon: true,
    popupContentClass: 'q-select-menu max-width',
    stackLabel: true
};

export const SELECT_MULTIPLE_MD_SEARCH = {
    borderless: true,
    bottomSlots: true,
    class: selectMdClasses,
    dropdownIcon: ICONS_NAME.CHEVRON_DOWN_SOLID,
    hideBottomSpace: true,
    inputDebounce: '500',
    maxlength: '250', // to replace v-bind="Object.assign({}, inputProps, {maxlength: X})"
    menuOffset: [0, 8],
    multiple: true,
    noErrorIcon: true,
    popupContentClass: 'q-select-menu max-width',
    stackLabel: true,
    useInput: true
};

export const CHECKBOX_PROPS = {
    class: 'form-field text-body1 text-primary-darker',
    checkedIcon: ICONS_NAME.CHECK_OUTLINE,
    uncheckedIcon: ICONS_NAME.CHECK_OUTLINE,
    indeterminateIcon: ICONS_NAME.LINE_OUTLINE
};

export const RADIO_PROPS = {
    size: '32px'
};

export const TOGGLE_SM = {
    class: 'q-toggle-sm',
    size: 'sm'
};

export const DATE_INPUT_LG = {
    borderless: true,
    bottomSlots: true,
    class: 'q-input-lg text-body1 form-field date-input q-input-date',
    debounce: '600',
    hideBottomSpace: true,
    noErrorIcon: true,
    stackLabel: true,
    lazyRules: true,
    readonly: true
};

export const DATE_INPUT_SM = {
    borderless: true,
    bottomSlots: true,
    class: 'q-input-sm text-body2 form-field date-input q-input-date',
    debounce: '600',
    hideBottomSpace: true,
    noErrorIcon: true,
    stackLabel: true,
    lazyRules: true,
    readonly: true
};
